import './assets/Content.css';
import React, { useContext, useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { ComponentInteractionEnum } from 'enums/ComponentInteractionEnum';
import { ComponentInteractionPositionEnum } from 'enums/ComponentInteractionPositionEnum';
import RecursoMediaSwitch from 'pages/recursos/recursos-conteudo/components/media-switch/RecursoMediaSwitch';
import { Collapse, ConfigProvider, Image, ProgressProps } from 'antd';
import Colors from 'enums/Colors';
import QuizInteractionPublic from 'pages/recursos/recursos-conteudo/components/quiz/QuizInteractionPublic';
import CarrosselInteractionPublic from 'pages/recursos/recursos-conteudo/components/carrossel/CarrosselInteractionPublic';
import ComponentAbasPublic from 'pages/recursos/recursos-conteudo/components/abas/ComponentAbasPublic';
import ComponentBaralhoPublic from 'pages/recursos/recursos-conteudo/components/baralho/ComponentBaralhoPublic';
import ReguaAvaliativaPublic from 'pages/recursos/recursos-conteudo/components/reguaAvaliativa/ReguaAvaliativaPublic';
import ComponentTimeLinesPublic from 'pages/recursos/recursos-conteudo/components/timelines/ComponentTimeLinesPublic';
import ComponentQuizPontucaoPublic from 'pages/recursos/recursos-conteudo/components/quiz/QuizPontuacaoPublic';
import ComponentCenarioPublic from 'pages/recursos/recursos-conteudo/components/cenario/ComponentCenarioPublic';
import CorrespondentPublic from 'pages/recursos/recursos-conteudo/components/correspondent/CorrespondentPublic';
import { CaretRightOutlined } from '@ant-design/icons';
import { fetchS3ComponentInteraction, fetchStorageFileAuthoringTools } from 'hooks/StoreFiles';
import { FAD_Button_NextInformation } from 'pages/ferramentaAutoria/components/FadButtons';

import { useHistory } from 'react-router-dom';
import { IsCustomMaxWidth } from 'core/util/WindowSize';
import ComponentInteractionModel from 'models/componentInteraction/ComponentInteraction';
import ComponentDividerPublic from 'pages/recursos/recursos-conteudo/components/dividers/ComponentDividerPublic';
import ComponentMarkPublic from 'pages/recursos/recursos-conteudo/components/mark/ComponentMarkPublic';
import ComponentHostpotPublic from 'pages/recursos/recursos-conteudo/components/hostpots/ComponentHostpotPublic';

import ComponentArrasteSoltePublic from 'pages/recursos/recursos-conteudo/components/arrasteSolte/ComponentArrasteSoltePublic';
import ComponentGameMemoryPublic from 'pages/recursos/recursos-conteudo/components/gameMemory/ComponentGameMemoryPublic';
import ComponentLacunaPublic from 'pages/recursos/recursos-conteudo/components/lacuna/ComponentLacunaPublic';
import ComponentCorrespondentImagemPublic from 'pages/recursos/recursos-conteudo/components/correspondent/CorrespondentImagemPublic';
import FadConentMenuLateralPublic from './components/FadContentMenuLateralPublic';
import { FerramentaAutoriaContext } from '../../context/FerramentaAutoriaContext';
import { createPortal } from 'react-dom';
import { OutlineButton } from 'components/UI/Buttons';
import { BlueButton } from 'pages/intermediarias/criatividadeDetail/versions/components/sections/Material.styled';
import { ButtonHomeV2 } from 'pages/home/components/homeV2/button/ButtonHomeV2.styled';
import { FadModulesAnexoModel } from 'models/ferramentaAutoria/FadModulesAnexoModel';

const StyledCaretRightOutlined = styled(CaretRightOutlined)``;

const Styled = {
    Container: styled.div`
        display: flex;
        width: 100%;
        padding-top: 90px;
        overflow-x: hidden;
    `,

    Contents: styled.div<{ menuOpen?: boolean }>`
        display: flex;
        flex-direction: column;

        gap: 16px;
        width: ${({ menuOpen }) => (menuOpen ? ' 80%' : ' 90%')};
        transition: all 0.5s ease-out;
        padding-left: ${({ menuOpen }) => (menuOpen ? '  90px' : '  132px')};
        transform: ${({ menuOpen }) => (menuOpen ? 'translateX(300px)' : 'translateX(40px)')};
        z-index: 0;

        @media screen and (max-width: 1600px) {
            padding-right: ${({ menuOpen }) => (menuOpen ? '  90px' : '  40px')};
        }

        @media screen and (max-width: 720px) {
            transform: ${({ menuOpen }) => (menuOpen ? 'translateX(300px)' : 'translateX(0px)')};
            width: 100%;
            padding: 16px;
        }
    `,

    RowBettween: styled.div`
        margin: 22px 0px;
        display: flex;
        justify-content: space-between;
        gap: 32px;

        @media screen and (max-width: 720px) {
            flex-direction: column;
            justify-content: start;
            gap: 16px;
        }
    `,

    TextContent: styled.p`
        font-family: 'Barlow', sans-serif !important;
        max-width: 100%;
        line-height: 1.4; /* Melhor espaçamento padrão */

        /* Ajustes para parágrafos */
        p {
            margin: 0 0 1em; /* Espaço entre parágrafos */
        }

        /* Listas */
        ol,
        ul {
            padding-left: 20px;
        }

        ol {
            list-style: inside decimal;
        }

        ul {
            list-style: inside disc;
        }

        /* Títulos */
        h1,
        h2 {
            font-weight: 700;
            margin: 0.5em 0;
        }

        h1 {
            font-size: 2em;
        }
        h2 {
            font-size: 1.5em;
        }
        h3 {
            font-size: 1.17em;
        }
        h4 {
            font-size: 1em;
        }
        h5 {
            font-size: 0.8em;
        }
        h6 {
            font-size: 0.6em;
        }

        /* Estilos do Quill */
        .ql-align-center {
            text-align: center;
        }
        .ql-align-right {
            text-align: right;
        }
        .ql-align-justify {
            text-align: justify;
        }

        .ql-bold {
            font-weight: bold;
        }
        .ql-italic {
            font-style: italic;
        }
        .ql-underline {
            text-decoration: underline;
        }
        .ql-strike {
            text-decoration: line-through;
        }

        .ql-blockquote {
            border-left: 4px solid #ccc;
            padding-left: 16px;
            margin-left: 0;
            font-style: italic;
        }

        .ql-code-block {
            background-color: #f4f4f4;
            padding: 8px;
            border-radius: 4px;
            font-family: monospace;
        }

        /* 🎨 Adicionando suporte para fontes do Quill */
        .ql-font-serif {
            font-family: serif;
        }
        .ql-font-monospace {
            font-family: monospace;
        }
        .ql-font-sans-serif {
            font-family: sans-serif;
        }

        /* Espaçamentos */
        .ql-size-small {
            font-size: 0.75em;
        }
        .ql-size-large {
            font-size: 1.5em;
        }
        .ql-size-huge {
            font-size: 2.5em;
        }

        /* Ajustes finos de espaçamento */
        .ql-indent-1 {
            margin-left: 20px;
        }
        .ql-indent-2 {
            margin-left: 40px;
        }
        .ql-indent-3 {
            margin-left: 60px;
        }
        .ql-indent-4 {
            margin-left: 80px;
        }

        iframe {
            width: 60%;
            min-height: 480px;
            display: flex;
            justify-self: center;

            @media screen and (max-width: 1920px) {
                width: 70%;
                height: 520px;
            }
            @media screen and (max-width: 1620px) {
                width: 80%;
                height: 520px;
            }
            @media screen and (max-width: 1320px) {
                width: 100%;
                height: 520px;
            }
        }
        img {
            display: flex;
            align-self: center;
            justify-self: center;
            max-width: 70%;
        }

        @media screen and (max-width: 720px) {
            img {
                max-width: 100% !important;
            }
        }
    `,

    ImgHeader: styled.div<{ img: string }>`
        background-image: url(${props => props.img});
        background-size: 100%;
        background-repeat: no-repeat;
        background-position: center;
        width: 100%;
        height: 320px;
        position: relative; /* Permite que elementos filhos com absolute fiquem dentro */
        display: flex;
        align-items: center;

        @media screen and (max-width: 1280px) {
            height: 240px;
        }
    `,

    HeaderTitle: styled.h1`
        position: absolute; /* Agora ele está dentro do ImgHeader */
        left: 200px;
        font-family: 'Barlow';
        font-weight: 700;
        line-height: 43.2px;
        text-align: left;
        max-width: calc(52% - 40px); /* Para evitar que saia da tela */

        @media screen and (max-width: 1668px) {
            left: 20px;
            margin-left: 10%;
            max-width: calc(55% - 20px);
        }
        @media screen and (max-width: 720px) {
            line-height: 24px;
            font-size: 22px;
            left: 0px;
            max-width: calc(55% - 20px);
        }
    `,
};

export const conicColors: ProgressProps['strokeColor'] = {
    '0%': '#d34710',
    '50%': '#ffe58f',
    '100%': '#0bd837',
};

// Hotjar eventos por curso

interface IAdminModalFadPreview {
    openModal: boolean;
    setOpenModal: (open: boolean) => void;
    anexo?: FadModulesAnexoModel | null;
    components: ComponentInteractionModel[];
}

const AdminModalFadPreview: React.FC<IAdminModalFadPreview> = ({ openModal, setOpenModal, anexo, components: allComponents }) => {
    const { contentSelected } = useContext(FerramentaAutoriaContext.Context);
    const [open, setOpen] = useState<boolean>(false);
    const history = useHistory();

    const [visibleSections, setVisibleSections] = useState<number[]>([0]);
    const [firstNextInformationIndex, setFirstNextInformationIndex] = useState<number | null>(null); // Índice do primeiro NEXT_INFORMATION
    const [nextInformationIndexHidden, setNextInformationIndexHidden] = useState<number[]>([]);

    //loaders

    const [completionPercentage, setCompletionPercentage] = useState(0);

    const refs = useRef<{ [key: number]: HTMLDivElement | null }>({});
    const componentRefs = useRef<{ [key: number]: HTMLDivElement | null }>({});

    const handleNextInformationHidden = (currentIndex: number) => {
        setNextInformationIndexHidden((prev: number[]) => [...prev, currentIndex]);
    };

    const handleNextInformationClick = (currentIndex: number) => {
        // Identifica os índices das seções que devem ser desbloqueadas
        if (allComponents) {
            const totalComponents = allComponents.length;

            // Filtrar os componentes visíveis (com base no índice presente em visibleSections)
            const visibleComponents = visibleSections.filter(
                index => allComponents[index] // Certifica-se de que o índice está dentro do contentView.componentes
            ).length;

            // Calcula a porcentagem de conclusão
            const newCompletionPercentage = Math.min((visibleComponents / totalComponents) * 100, 100);

            // Condição para marcar como 100% apenas se todos os componentes forem visíveis
            const isComplete = visibleComponents === totalComponents;

            setCompletionPercentage(isComplete ? 100 : newCompletionPercentage);

            const nextVisibleSections: number[] = [];
            let nextComponentId: number | null = null;

            for (let i = currentIndex + 1; i < allComponents.length; i++) {
                const component = allComponents[i];
                nextVisibleSections.push(i);

                // Guarda o ID do próximo componente para rolar até ele
                if (!nextComponentId) {
                    nextComponentId = component.id;
                }

                if (component.tipo === ComponentInteractionEnum.NEXT_INFORMATION) {
                    break;
                }
            }

            setVisibleSections(prev => [...prev, ...nextVisibleSections]);

            const SCROLL_MARGIN_TOP = 100;

            requestAnimationFrame(() => {
                setTimeout(() => {
                    // Seleciona todos os novos componentes visíveis
                    const visibleElements = nextVisibleSections
                        .map(index => componentRefs.current[allComponents[index].id])
                        .filter(el => el !== undefined);

                    if (visibleElements.length > 0) {
                        const firstElement = visibleElements[0]; // Primeiro novo componente visível
                        const lastElement = visibleElements[visibleElements.length - 1]; // Último novo componente visível

                        if (firstElement && lastElement) {
                            const firstElementRect = firstElement.getBoundingClientRect();
                            const lastElementRect = lastElement.getBoundingClientRect();
                            const windowHeight = window.innerHeight;

                            // Calcula a altura total dos novos componentes visíveis
                            const totalNewContentHeight = lastElementRect.bottom - firstElementRect.top;

                            if (totalNewContentHeight < windowHeight) {
                                // Se os novos componentes ocupam menos espaço que a tela, alinhar o último com o final da tela
                                window.scrollTo({
                                    top: window.scrollY + lastElementRect.bottom - windowHeight,
                                    behavior: 'smooth',
                                });
                            } else {
                                // Se os novos componentes forem grandes, rola até o primeiro
                                const topPosition = firstElementRect.top + window.scrollY - SCROLL_MARGIN_TOP;

                                window.scrollTo({
                                    top: topPosition,
                                    behavior: 'smooth',
                                });
                            }
                        }
                    }
                }, 200); // Pequeno atraso para garantir que os elementos estejam renderizados antes do scroll
            });
        }
    };

    function isScreenSmallerThan(width: number) {
        return window.innerWidth < width;
    }

    useEffect(() => {
        if (!isScreenSmallerThan(720)) {
            setOpen(true);
        }
    }, []);

    useEffect(() => {
        if (allComponents) {
            const firstNextIndex = allComponents.findIndex(component => component.tipo === ComponentInteractionEnum.NEXT_INFORMATION);

            if (firstNextIndex !== -1) {
                setFirstNextInformationIndex(firstNextIndex);

                // Torna visíveis todos os componentes antes do primeiro NEXT_INFORMATION e o próprio NEXT_INFORMATION
                const initialVisibleSections = Array.from({ length: firstNextIndex + 1 }, (_, i) => i);
                setVisibleSections(initialVisibleSections);
            } else {
                setFirstNextInformationIndex(null);
            }
        }
    }, [allComponents]);

    useEffect(() => {
        setNextInformationIndexHidden([]);

        window.scrollTo(0, 0);
    }, [allComponents]);

    return (
        <>
            {createPortal(
                <div
                    style={{
                        display: openModal ? 'flex' : 'none',
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100vw',
                        height: '100vh',
                        backgroundColor: '#fff',
                        zIndex: 100,
                        overflow: 'auto',
                        overflowY: 'scroll',
                        flexDirection: 'column',
                        paddingBottom: '40px',
                    }}
                >
                    <Styled.Container>
                        <FadConentMenuLateralPublic
                            open={open}
                            setOpen={setOpen}
                            porcentContentAtt={completionPercentage}
                            isPrivate={true}
                            hiddendModalPreview={openModal}
                            setModalPreview={setOpenModal}
                        />

                        <Styled.Contents menuOpen={open}>
                            <div style={{ position: 'relative' }} ref={el => (refs.current[contentSelected?.codigo ?? -1] = el)}>
                                <Styled.ImgHeader img={fetchStorageFileAuthoringTools(anexo?.filepath ?? '')}>
                                    <Styled.HeaderTitle style={{ color: contentSelected?.corText, fontSize: contentSelected?.textFontSize }}>
                                        {contentSelected?.title}
                                    </Styled.HeaderTitle>
                                </Styled.ImgHeader>
                            </div>
                            {allComponents &&
                                allComponents
                                    .sort((a, b) => a.ordem - b.ordem)
                                    .map((components, indexComponent) => {
                                        const componentRef = (el: HTMLDivElement | null) => {
                                            componentRefs.current[components.id] = el;
                                        };

                                        const existNextInformation = allComponents.some(
                                            (c: ComponentInteractionModel) => c.tipo === ComponentInteractionEnum.NEXT_INFORMATION
                                        );

                                        const isVisible = visibleSections.includes(indexComponent);

                                        if (!isVisible && existNextInformation) {
                                            return null;
                                        }

                                        if (components.tipo === ComponentInteractionEnum.AUDIO) {
                                            return (
                                                <div
                                                    style={{
                                                        marginTop: 22,
                                                        marginBottom: 22,
                                                    }}
                                                    key={components.id}
                                                    className={`component-container ${isVisible ? 'fade-in-up' : ''}`}
                                                    ref={componentRef}
                                                >
                                                    <RecursoMediaSwitch anexoUrl={components.conteudo} />
                                                </div>
                                            );
                                        }

                                        if (components.tipo === ComponentInteractionEnum.TEXT) {
                                            return (
                                                <div
                                                    key={components.id}
                                                    style={{
                                                        backgroundColor: components.cor ?? '',
                                                        padding: 8,
                                                        marginTop: 22,
                                                        marginBottom: 22,
                                                    }}
                                                >
                                                    <Styled.TextContent
                                                        className={`component-container ${isVisible ? 'fade-in-up' : ''}`}
                                                        ref={componentRef}
                                                        dangerouslySetInnerHTML={{ __html: components.conteudo ?? '' }}
                                                    />
                                                </div>
                                            );
                                        }
                                        if (components.tipo === ComponentInteractionEnum.NEXT_INFORMATION) {
                                            return (
                                                <div
                                                    key={components.id}
                                                    ref={componentRef}
                                                    className={`component-container ${isVisible ? 'fade-in-up' : ''}`}
                                                    style={{
                                                        display: nextInformationIndexHidden.includes(indexComponent) ? 'none' : 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        margin: 22,
                                                    }}
                                                >
                                                    <FAD_Button_NextInformation
                                                        text="Continuar"
                                                        onClick={() => {
                                                            handleNextInformationClick(indexComponent);
                                                            handleNextInformationHidden(indexComponent);
                                                        }}
                                                        styles={{ width: 600 }}
                                                    />
                                                </div>
                                            );
                                        }
                                        if (components.tipo === ComponentInteractionEnum.TWO_TEXT) {
                                            return (
                                                <div
                                                    key={components.id}
                                                    style={{ display: 'flex' }}
                                                    className={`component-container ${isVisible ? 'fade-in-up' : ''}`}
                                                >
                                                    <Styled.TextContent
                                                        ref={componentRef}
                                                        style={{ width: '50%', padding: '8px' }}
                                                        dangerouslySetInnerHTML={{ __html: components.conteudo ?? '' }}
                                                    />
                                                    <Styled.TextContent
                                                        ref={componentRef}
                                                        style={{ width: '50%', padding: '8px' }}
                                                        dangerouslySetInnerHTML={{ __html: components.conteudoTwo ?? '' }}
                                                    />
                                                </div>
                                            );
                                        }
                                        if (components.tipo === ComponentInteractionEnum.TEXT_IMG_LEFT) {
                                            const getAlignItems = () => {
                                                const position = components.positionImg || ComponentInteractionPositionEnum.CENTER;
                                                switch (position) {
                                                    case ComponentInteractionPositionEnum.TOP:
                                                        return 'flex-start';
                                                    case ComponentInteractionPositionEnum.BOTTOM:
                                                        return 'flex-end';
                                                    case ComponentInteractionPositionEnum.CENTER:
                                                    default:
                                                        return 'center';
                                                }
                                            };

                                            return (
                                                <Styled.RowBettween
                                                    key={components.id}
                                                    className={`component-container ${isVisible ? 'fade-in-up' : ''}`}
                                                    style={{ alignItems: getAlignItems() }}
                                                >
                                                    {components.anexo && (
                                                        <Image
                                                            preview={false}
                                                            style={{
                                                                display: 'flex',
                                                                maxWidth: components.customImg ? "auto" : '1200px',
                                                                width: components.customImg ? components.sizeImgWidth + "px" : 'auto',
                                                                height: components.customImg ? components.sizeImgHeight + "px" : 'auto',
                                                                position: 'relative',
                                                                objectFit: "cover",
                                                            }}
                                                            src={fetchS3ComponentInteraction(components.anexo.filepath)}
                                                        />
                                                    )}

                                                    <Styled.TextContent
                                                        style={{ margin: 0, width: '90%' }}
                                                        ref={componentRef}
                                                        onMouseOver={e => {
                                                            const target = e.target as HTMLImageElement;
                                                            if (target.tagName === 'IMG') {
                                                            }
                                                        }}
                                                        dangerouslySetInnerHTML={{ __html: components.conteudo ?? '' }}
                                                    />
                                                </Styled.RowBettween>
                                            );
                                        }
                                        if (components.tipo === ComponentInteractionEnum.TEXT_IMG_RIGHT) {
                                            const getAlignItems = () => {
                                                const position = components.positionImg || ComponentInteractionPositionEnum.CENTER;
                                                switch (position) {
                                                    case ComponentInteractionPositionEnum.TOP:
                                                        return 'flex-start';
                                                    case ComponentInteractionPositionEnum.BOTTOM:
                                                        return 'flex-end';
                                                    case ComponentInteractionPositionEnum.CENTER:
                                                    default:
                                                        return 'center';
                                                }
                                            };

                                            return (
                                                <Styled.RowBettween
                                                    key={components.id}
                                                    className={`component-container ${isVisible ? 'fade-in-up' : ''}`}
                                                    style={{ alignItems: getAlignItems() }}
                                                >
                                                    <Styled.TextContent
                                                        style={{ margin: 0, width: !open ? '89%' : '100%' }}
                                                        ref={componentRef}
                                                        dangerouslySetInnerHTML={{ __html: components.conteudo ?? '' }}
                                                    />
                                                    {components.anexo && (
                                                        <Image
                                                            preview={false}
                                                            style={{
                                                                maxWidth: '1200px',
                                                            }}
                                                            src={fetchS3ComponentInteraction(components.anexo.filepath)}
                                                        />
                                                    )}
                                                </Styled.RowBettween>
                                            );
                                        }

                                        if (components.tipo === ComponentInteractionEnum.TEXT_HIGHLIGHTED) {
                                            return (
                                                <div
                                                    key={components.id}
                                                    style={{
                                                        position: 'relative',
                                                        width: '100%',
                                                        minHeight: '300px', // Mantém a altura mínima de 300px
                                                        display: 'flex',
                                                        padding: '54px 12px',
                                                        margin: '22px 0px',
                                                        justifyContent: 'center',
                                                        overflow: 'hidden', // Garante que a imagem não ultrapasse os limites do contêiner
                                                    }}
                                                    className={`component-container ${isVisible ? 'fade-in-up' : ''}`}
                                                >
                                                    {/* Imagem de fundo */}
                                                    {components.anexo && (
                                                        <div
                                                            style={{
                                                                position: 'absolute',
                                                                top: 0,
                                                                left: 0,
                                                                width: '100%',
                                                                height: '100%',
                                                                backgroundImage: `url(${fetchS3ComponentInteraction(
                                                                    components.anexo.filepath
                                                                )})`,
                                                                backgroundSize: 'cover', // Mantém a proporção e cobre todo o contêiner
                                                                backgroundPosition: 'center', // Centraliza a imagem
                                                                backgroundRepeat: 'no-repeat', // Evita repetições
                                                                zIndex: 0, // Mantém a imagem no fundo
                                                            }}
                                                        />
                                                    )}

                                                    {/* Texto sobre a imagem */}
                                                    <Styled.TextContent
                                                        style={{
                                                            margin: 0,
                                                            width: '100%',
                                                            position: 'relative', // Mantém o texto acima da imagem
                                                            zIndex: 1, // Coloca o texto sobre a imagem
                                                            color: 'white', // Ajusta a cor do texto para contraste
                                                            borderRadius: '5px',
                                                        }}
                                                        ref={componentRef}
                                                        // onClick={e => {
                                                        //     const target = e.target as HTMLImageElement;
                                                        //     if (target.tagName === 'IMG') {
                                                        //         openModal(target.src);
                                                        //     }
                                                        // }}
                                                        dangerouslySetInnerHTML={{ __html: components.conteudo ?? '' }}
                                                    />
                                                </div>
                                            );
                                        }

                                        if (components.tipo === ComponentInteractionEnum.SANFONA) {
                                            return (
                                                <ConfigProvider
                                                    key={components.id}
                                                    collapse={{
                                                        style: {
                                                            backgroundColor: components.cor ?? '',
                                                            marginBottom: '22px',
                                                        },
                                                    }}
                                                >
                                                    <Collapse
                                                        size="large"
                                                        className={`component-container ${isVisible ? 'fade-in-up' : ''}`}
                                                        ref={componentRef}
                                                        items={components.sanfona?.map((sanfona, idxSanfona) => ({
                                                            key: idxSanfona,
                                                            label: (
                                                                <h1
                                                                    style={{
                                                                        color:
                                                                            components.cor === Colors.Blue || components.cor === Colors.SoftBlue
                                                                                ? Colors.White
                                                                                : Colors.Blue,
                                                                        fontWeight: 700,
                                                                    }}
                                                                >
                                                                    {sanfona.titulo}
                                                                </h1>
                                                            ),
                                                            children: (
                                                                <>
                                                                    {sanfona.componentSanfonaConteudos?.map((conteudo, idxConteudo) => {
                                                                        if (conteudo.tipoConteudo === ComponentInteractionEnum.TEXT) {
                                                                            return (
                                                                                <Styled.TextContent
                                                                                    style={{
                                                                                        margin: 0,
                                                                                        padding: 10,
                                                                                    }}
                                                                                    key={idxConteudo}
                                                                                    onMouseOver={e => {
                                                                                        const target = e.target as HTMLImageElement;
                                                                                        if (target.tagName === 'IMG') {
                                                                                        }
                                                                                    }}
                                                                                    dangerouslySetInnerHTML={{
                                                                                        __html: conteudo.conteudo ?? '',
                                                                                    }}
                                                                                />
                                                                            );
                                                                        }

                                                                        if (conteudo.tipoConteudo === ComponentInteractionEnum.AUDIO) {
                                                                            return (
                                                                                <RecursoMediaSwitch
                                                                                    key={idxConteudo}
                                                                                    anexoUrl={conteudo.conteudo}
                                                                                />
                                                                            );
                                                                        }
                                                                    })}
                                                                </>
                                                            ),
                                                        }))}
                                                        expandIcon={({ isActive }) => (
                                                            <StyledCaretRightOutlined
                                                                style={{
                                                                    color:
                                                                        components.cor === Colors.Blue || components.cor === Colors.SoftBlue
                                                                            ? Colors.White
                                                                            : Colors.Blue,
                                                                }}
                                                                size={22}
                                                                rotate={isActive ? 90 : 0}
                                                            />
                                                        )}
                                                    />
                                                </ConfigProvider>
                                            );
                                        }

                                        if (components.tipo === ComponentInteractionEnum.QUIZ) {
                                            return (
                                                <div
                                                    key={components.id}
                                                    ref={componentRef}
                                                    className={`component-container ${isVisible ? 'fade-in-up' : ''}`}
                                                >
                                                    <QuizInteractionPublic
                                                        quizzes={components.quiz ?? []}
                                                        componente={components}
                                                        openModal={() => ''}
                                                        setBlockConcluirConteudo={b => {}}
                                                        handleSaveAvaliation={v => {}}
                                                        handleSaveAvaliationComponents={v => v}
                                                    />
                                                </div>
                                            );
                                        }

                                        if (components.tipo === ComponentInteractionEnum.CORRESPONDENT) {
                                            return (
                                                <div
                                                    key={components.id}
                                                    ref={componentRef}
                                                    className={`component-container ${isVisible ? 'fade-in-up' : ''}`}
                                                >
                                                    <CorrespondentPublic
                                                        dados={components.correspondent}
                                                        component={components}
                                                        handleSaveAvaliation={v => {}}
                                                        handleSaveAvaliationComponents={v => v}
                                                    />
                                                </div>
                                            );
                                        }

                                        if (components.tipo === ComponentInteractionEnum.CARROSSEL) {
                                            return (
                                                <div
                                                    key={components.id}
                                                    ref={componentRef}
                                                    className={`component-container ${isVisible ? 'fade-in-up' : ''}`}
                                                >
                                                    <CarrosselInteractionPublic dados={components.carrossel} />
                                                </div>
                                            );
                                        }

                                        if (components.tipo === ComponentInteractionEnum.ABAS) {
                                            return (
                                                <div
                                                    key={components.id}
                                                    ref={componentRef}
                                                    className={`component-container ${isVisible ? 'fade-in-up' : ''}`}
                                                >
                                                    <ComponentAbasPublic
                                                        dados={components.abas}
                                                        openModal={() => ''}
                                                        corBackground={components.cor as Colors}
                                                    />
                                                </div>
                                            );
                                        }

                                        if (components.tipo === ComponentInteractionEnum.CARD_BARALHO) {
                                            return (
                                                <div
                                                    key={components.id}
                                                    ref={componentRef}
                                                    className={`component-container ${isVisible ? 'fade-in-up' : ''}`}
                                                >
                                                    <ComponentBaralhoPublic
                                                        dados={components.baralho ?? []}
                                                        quantityVisible={components.quantityVisible}
                                                        centralized
                                                        isFad
                                                    />
                                                </div>
                                            );
                                        }

                                        if (components.tipo === ComponentInteractionEnum.REGUA_AVALIATIVA && components.reguaAvaliativa) {
                                            return (
                                                <div
                                                    key={components.id}
                                                    ref={componentRef}
                                                    className={`component-container ${isVisible ? 'fade-in-up' : ''}`}
                                                >
                                                    <ReguaAvaliativaPublic
                                                        dados={components.reguaAvaliativa}
                                                        component={components}
                                                        handleSaveAvaliation={v => {}}
                                                    />
                                                </div>
                                            );
                                        }
                                        if (components.tipo === ComponentInteractionEnum.TIMELINE && components.timelines) {
                                            return (
                                                <div
                                                    key={components.id}
                                                    ref={componentRef}
                                                    className={`component-container ${isVisible ? 'fade-in-up' : ''}`}
                                                >
                                                    <ComponentTimeLinesPublic dados={components.timelines} color={components.cor ?? ''} />
                                                </div>
                                            );
                                        }
                                        if (components.tipo === ComponentInteractionEnum.QUIZ_PONTUACAO && components.quizPontuacao) {
                                            return (
                                                <div
                                                    key={components.id}
                                                    ref={componentRef}
                                                    className={`component-container ${isVisible ? 'fade-in-up' : ''}`}
                                                >
                                                    <ComponentQuizPontucaoPublic
                                                        dados={components.quizPontuacao}
                                                        component={components}
                                                        handleSaveAvaliation={v => {}}
                                                    />
                                                </div>
                                            );
                                        }
                                        if (components.tipo === ComponentInteractionEnum.CENARIO && components.cenarios) {
                                            return (
                                                <div
                                                    key={components.id}
                                                    ref={componentRef}
                                                    className={`component-container ${isVisible ? 'fade-in-up' : ''}`}
                                                >
                                                    <ComponentCenarioPublic dados={components.cenarios} />
                                                </div>
                                            );
                                        }
                                        if (
                                            components.tipo === ComponentInteractionEnum.DIVIDER_LINE ||
                                            components.tipo === ComponentInteractionEnum.DIVIDER_LINE_WITH_NUMBER
                                        ) {
                                            return (
                                                <div
                                                    key={components.id}
                                                    ref={componentRef}
                                                    className={`component-container ${isVisible ? 'fade-in-up' : ''}`}
                                                >
                                                    <ComponentDividerPublic dados={components} />
                                                </div>
                                            );
                                        }
                                        if (components.tipo === ComponentInteractionEnum.MARK_TEXT && components.marks) {
                                            return (
                                                <div
                                                    key={components.id}
                                                    ref={componentRef}
                                                    className={`component-container ${isVisible ? 'fade-in-up' : ''}`}
                                                >
                                                    <ComponentMarkPublic dados={components} />
                                                </div>
                                            );
                                        }

                                        if (components.tipo === ComponentInteractionEnum.HOSTPOT && components.hostpots) {
                                            return (
                                                <div
                                                    key={components.id}
                                                    ref={componentRef}
                                                    className={`component-container ${isVisible ? 'fade-in-up' : ''}`}
                                                >
                                                    <ComponentHostpotPublic dados={components} />
                                                </div>
                                            );
                                        }
                                        if (components.tipo === ComponentInteractionEnum.ARRASTE_SOLTE && components.arrasteSolte) {
                                            return (
                                                <div
                                                    key={components.id}
                                                    ref={componentRef}
                                                    className={`component-container ${isVisible ? 'fade-in-up' : ''}`}
                                                >
                                                    <ComponentArrasteSoltePublic dados={components.arrasteSolte} />
                                                </div>
                                            );
                                        }
                                        if (components.tipo === ComponentInteractionEnum.GAME_MEMORY && components.gameMemorys) {
                                            return (
                                                <div
                                                    key={components.id}
                                                    ref={componentRef}
                                                    className={`component-container ${isVisible ? 'fade-in-up' : ''}`}
                                                >
                                                    <ComponentGameMemoryPublic dados={components.gameMemorys} />
                                                </div>
                                            );
                                        }
                                        if (components.tipo === ComponentInteractionEnum.LACUNAS && components.lacunas) {
                                            return (
                                                <div
                                                    key={components.id}
                                                    ref={componentRef}
                                                    className={`component-container ${isVisible ? 'fade-in-up' : ''}`}
                                                >
                                                    <ComponentLacunaPublic dados={components.lacunas} />
                                                </div>
                                            );
                                        }
                                        if (
                                            components.tipo === ComponentInteractionEnum.CORRESPONDENT_IMAGEM &&
                                            components.correspondentImagem
                                        ) {
                                            return (
                                                <div
                                                    key={components.id}
                                                    ref={componentRef}
                                                    className={`component-container ${isVisible ? 'fade-in-up' : ''}`}
                                                >
                                                    <ComponentCorrespondentImagemPublic dados={components.correspondentImagem} />
                                                </div>
                                            );
                                        }
                                    })}
                        </Styled.Contents>
                    </Styled.Container>
                </div>,
                document.body
            )}
        </>
    );
};

export default AdminModalFadPreview;
